import React from 'react';

/**
 * 모패밀리 대표 아바타. imageUrl 있으면 이미지, 없으면 이름 첫 글자 +
 * mo_family_hash 기반 deterministic 색상 원.
 */
export const FamilyAvatar: React.FC<{
 name: string;
 familyHash: string;
 imageUrl?: string | null;
 size?: number;
}> = ({ name, familyHash, imageUrl, size = 48 }) => {
 const dim = `${size}px`;
 if (imageUrl) {
  return (
   <img
    src={imageUrl}
    alt=""
    className="rounded-lg object-cover border border-gray-200 flex-shrink-0"
    style={{ width: dim, height: dim }}
   />
  );
 }
 const initial = (name?.trim()?.[0] ?? '?').toUpperCase();
 const bg = colorFromHash(familyHash || name);
 const fontSize = Math.max(12, Math.floor(size * 0.45));
 return (
  <div
   className="rounded-lg flex items-center justify-center text-white font-medium select-none flex-shrink-0"
   style={{ width: dim, height: dim, backgroundColor: bg, fontSize: `${fontSize}px` }}
   aria-hidden="true"
  >
   {initial}
  </div>
 );
};

function colorFromHash(s: string): string {
 let h = 0;
 for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
 const hue = ((h % 360) + 360) % 360;
 return `hsl(${hue}, 60%, 55%)`;
}
